import { render, staticRenderFns } from "./ProjectFilesCarousel.vue?vue&type=template&id=0834c288&scoped=true"
import script from "./ProjectFilesCarousel.vue?vue&type=script&lang=js"
export * from "./ProjectFilesCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProjectFilesCarousel.vue?vue&type=style&index=0&id=0834c288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834c288",
  null
  
)

export default component.exports